import ApiService from 'app/services/ApiService';

export const GET_SYSTEM_NAMES_REQUEST = 'GET_SYSTEM_NAMES_REQUEST';
export const GET_SYSTEM_NAMES_SUCCESS = 'GET_SYSTEM_NAMES_SUCCESS';
export const GET_SYSTEM_NAMES_FAILURE = 'GET_SYSTEM_NAMES_FAILURE';
export const GET_KEYUSER_NAMES_REQUEST = 'GET_KEYUSER_NAMES_REQUEST';
export const GET_KEYUSER_NAMES_SUCCESS = 'GET_KEYUSER_NAMES_SUCCESS';
export const GET_KEYUSER_NAMES_FAILURE = 'GET_KEYUSER_NAMES_FAILURE';
export const GET_FUNCTIONAL_NAMES_REQUEST = 'GET_FUNCTIONAL_NAMES_REQUEST';
export const GET_FUNCTIONAL_NAMES_SUCCESS = 'GET_FUNCTIONAL_NAMES_SUCCESS';
export const GET_FUNCTIONAL_NAMES_FAILURE = 'GET_FUNCTIONAL_NAMES_FAILURE';
export const GET_SUBDIRECTION_REQUEST = 'GET_SUBDIRECTION_REQUEST';
export const GET_SUBDIRECTION_SUCCESS = 'GET_SUBDIRECTION_SUCCESS';
export const GET_SUBDIRECTION_FAILURE = 'GET_SUBDIRECTION_FAILURE';
export const FETCH_SYSTEM_REQUEST = 'FETCH_SYSTEM_REQUEST';
export const FETCH_SYSTEM_SUCCESS = 'FETCH_SYSTEM_SUCCESS';
export const FETCH_SYSTEM_FAILURE = 'FETCH_SYSTEM_FAILURE';
export const EXPORT_SYSTEM_REQUEST = 'EXPORT_SYSTEM_REQUEST';
export const EXPORT_SYSTEM_SUCCESS = 'EXPORT_SYSTEM_SUCCESS';
export const EXPORT_SYSTEM_FAILURE = 'EXPORT_SYSTEM_FAILURE';
export const INSUPD_SYSTEM_REQUEST = 'INSUPD_SYSTEM_REQUEST';
export const INSUPD_SYSTEM_SUCCESS = 'INSUPD_SYSTEM_SUCCESS';
export const INSUPD_SYSTEM_FAILURE = 'INSUPD_SYSTEM_FAILURE';
export const DELETE_SYSTEM_REQUEST = 'DELETE_SYSTEM_REQUEST';
export const DELETE_SYSTEM_SUCCESS = 'DELETE_SYSTEM_SUCCESS';
export const DELETE_SYSTEM_FAILURE = 'DELETE_SYSTEM_FAILURE';
export const GET_SYSTEMSPECIALTY_REQUEST = 'GET_SYSTEMSPECIALTY_REQUEST';
export const GET_SYSTEMSPECIALTY_SUCCESS = 'GET_SYSTEMSPECIALTY_SUCCESS';
export const GET_SYSTEMSPECIALTY_FAILURE = 'GET_SYSTEMSPECIALTY_FAILURE';

export const GET_ALLKEYUSER_NAMES_REQUEST = 'GET_ALLKEYUSER_NAMES_REQUEST';
export const GET_ALLKEYUSER_NAMES_SUCCESS = 'GET_ALLKEYUSER_NAMES_SUCCESS';
export const GET_ALLKEYUSER_NAMES_FAILURE = 'GET_ALLKEYUSER_NAMES_FAILURE';

export const SAVE_PAGINATION = 'SAVE_PAGINATION';
export const SAVE_FILTER = 'SAVE_FILTER';
export const CLEAR_REDUCER = 'CLEAR_REDUCER';

export const getNames = (subdirection) => dispatch => {
    dispatch({ type: GET_SYSTEM_NAMES_REQUEST });
    ApiService.getSystemNames(subdirection).then(
        response => {
            dispatch({
                type: GET_SYSTEM_NAMES_SUCCESS,
                payload: response.listData
            });
        }
    ).catch(
        (error) => {
            dispatch({ type: GET_SYSTEM_NAMES_FAILURE, payload: error.response.message });
        }
    )
}

export const getKeyUsers = (subdirection) => dispatch => {
    dispatch({ type: GET_KEYUSER_NAMES_REQUEST });
    ApiService.getKeyUserNames(subdirection).then(
        response => {
            dispatch({
                type: GET_KEYUSER_NAMES_SUCCESS,
                payload: response.listData
            });
        }
    ).catch(
        (error) => {
            dispatch({ type: GET_KEYUSER_NAMES_FAILURE, payload: error.response.message });
        }
    )
}

export const getAllKeyUsers = () => dispatch => {
    dispatch({ type: GET_ALLKEYUSER_NAMES_REQUEST });
    ApiService.getAllKeyUserNames().then(
        response => {
            dispatch({
                type: GET_ALLKEYUSER_NAMES_SUCCESS,
                payload: response.listData
            });
        }
    ).catch(
        (error) => {
            dispatch({ type: GET_ALLKEYUSER_NAMES_FAILURE, payload: error.response.message });
        }
    )
}

export const getEditKeyUsers = (params) => dispatch => {
    dispatch({ type: GET_ALLKEYUSER_NAMES_REQUEST });
    ApiService.getEditKeyUserNames(params).then(
        response => {
            return response.listData;
        }
    ).catch(
        (error) => {
            return [];
        }
    )
}

export const getFunctionals = (subdirection) => dispatch => {
    dispatch({ type: GET_FUNCTIONAL_NAMES_REQUEST });
    ApiService.getFunctionalNames(subdirection).then(
        response => {
            dispatch({
                type: GET_FUNCTIONAL_NAMES_SUCCESS,
                payload: response.listData
            });
        }
    ).catch(
        (error) => {
            dispatch({ type: GET_FUNCTIONAL_NAMES_FAILURE, payload: error.response.message });
        }
    )
}

export const fetchSystems = (param) => dispatch => {
    let objValidate = {}

    for (const [key, value] of Object.entries(param)) {
        if (value) {
            objValidate[key] = value
        }
    }

    dispatch({ type: FETCH_SYSTEM_REQUEST });
    ApiService.fetchSystems(objValidate).then(
        response => {
            dispatch({
                type: FETCH_SYSTEM_SUCCESS,
                payload: response.listData
            });
        }
    ).catch(
        (error) => dispatch({ type: FETCH_SYSTEM_FAILURE, payload: error.response !== undefined ? error.response.data.message : error.message })
    )
}

export const exportXls = (param) => dispatch => {
    let objValidate = {}

    for (const [key, value] of Object.entries(param)) {
        if (value) {
            objValidate[key] = value
        }
    }

    dispatch({ type: EXPORT_SYSTEM_REQUEST });
    ApiService.exportSystems(objValidate).then(
        result => {
            const blob = new Blob([result], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
            downloadFile(blob, "CatalogoSistemas.xlsx");

            dispatch({ type: EXPORT_SYSTEM_SUCCESS });
        }
    ).catch(
        (error) => dispatch({ type: EXPORT_SYSTEM_FAILURE, payload: error.message })
    )
}

export const insUpdSystem = (data, callback) => dispatch => {
    dispatch({ type: INSUPD_SYSTEM_REQUEST });
    ApiService.insUpdSystem(data).then(
        response => {
            dispatch({
                type: INSUPD_SYSTEM_SUCCESS,
                payload: "El sistema " + data.systemName + " se guardo correctamente"
            });

            if (typeof callback === 'function') {
                callback();
            }
        }
    ).catch(
        (error) => dispatch({ type: INSUPD_SYSTEM_FAILURE, payload: error.response !== undefined ? error.response.data.message : error.message })
    )
}

export const deleteSystem = (data, callback) => dispatch => {
    dispatch({ type: DELETE_SYSTEM_REQUEST });
    ApiService.deleteSystem(data.idSystem).then(
        response => {
            dispatch({
                type: DELETE_SYSTEM_SUCCESS,
                payload: "Se eliminó correctamente el sistema " + data.systemName
            })

            if (typeof callback === 'function') {
                callback();
            }
        }
    ).catch(
        (error) => dispatch({ type: DELETE_SYSTEM_FAILURE, payload: error.response !== undefined ? error.response.data.message : error.message })
    )
}

export const getSystemSpecialty = (idSubdirection) => dispatch => {
    dispatch({ type: GET_SYSTEMSPECIALTY_REQUEST });
    ApiService.getSystemSpecialty(idSubdirection).then(
        response => {
            dispatch({
                type: GET_SYSTEMSPECIALTY_SUCCESS,
                payload: response.listData
            });
        }
    ).catch(
        (error) => dispatch({ type: GET_SYSTEMSPECIALTY_FAILURE, payload: error.response !== undefined ? error.response.data.message : error.message })
    )
}

export const clear = () => ({
    type: CLEAR_REDUCER
});

export const saveFilter = (filter) => ({
    type: SAVE_FILTER,
    payload: filter
});

export const savePagination = (pagination) => ({
    type: SAVE_PAGINATION,
    payload: pagination
});

//Aux functions
const downloadFile = (blob, fileName) => {
    const link = document.createElement('a');
    link.href = URL.createObjectURL(blob);
    link.download = fileName;
    document.body.append(link);
    link.click();
    link.remove();
    window.addEventListener('focus', e => URL.revokeObjectURL(link.href), { once: true });
};